<template>
  <div class="card p-2 shadow">
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-md-6 d-flex flex-column">
          <div class="mb-2 fw-bold text-truncate lead">
            {{ companyName }} - {{ companySiret }}
          </div>
          <div> {{ companyAddress }} </div>
        </div>
        <div class="col-12 d-md-flex col-md-3 my-auto">
          <div
            class="badge badge-pill rounded-pill px-2 fs-6 fw-bold lead mt-1"
            :class="companyCurrent ? 'bg-green-300' : 'bg-gray-300 cursor-pointer'"
          >
            {{ companyCurrent ? 'Connectée' : 'Déconnectée' }}
          </div>
        </div>
        <div class="col-12 col-md-3 d-flex my-auto">
          <div class="ms-md-auto mt-1 mt-md-0 d-flex w-100">
            <router-link
              v-slot="{ navigate }"
              :to="`/client/account/companies/${company.id}`"
              custom
            >
              <v-loader
                :next="(event) => navigateTo(navigate, event)"
                title="Voir"
                icon="arrow-white-right"
                class="my-auto text-nowrap w-100"
              />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { ui } from '@/mixins';

export default {
  mixins: [ui],
  props: {
    company: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    companyName() {
      return this.company.name;
    },
    companySiret() {
      return this.company.siret;
    },
    companyAddress() {
      if (this.company.address.street) {
        return `${this.company.address.street} ${this.company.address.city} ${this.company.address.postalCode} ${this.company.address.country}`;
      }
      return this.company.address;
    },
    companyCurrent() {
      if (this.company.current === false) {
        return false;
      }
      return true;
    },
  },
  methods: {
    navigateTo(navigate, event) {
      this.$store.dispatch('company/setSelectedCompany', this.company.id);
      navigate(event);
      return Promise.resolve();
    },
  },
};
</script>
